import React from 'react';
import { getStageColorV2 } from '../../../../utils';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme: any) => ({
  stageColor: {
    background: ({ name }: { name: string }) => getStageColorV2(name, theme),
    width: theme.spacing(0.5),
    height: theme.spacing(3),
    borderRadius: theme.spacing(0.5),
    marginRight: theme.spacing(2),
  },
}));
export default function MobileStageColor({ name }: { name: string }) {
  const classes = useStyles({ name });

  return <div className={classes.stageColor} />;
}
